import type { SortIconProps } from './types';

const sortStringArr = ['up', 'default', 'down'];

export const SortIcon: React.FC<SortIconProps> = ({ sortDirection }) => <img aria-label="sorticon" src={`/static/front/assets/table/sort-${sortStringArr[sortDirection + 1]}.png`} />;
